export default "__VITE_ASSET__DCB1wOAq__"